import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Accordion, Row, Card, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAgent from "../../../core/api/api.agent";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { FormProvider, useForm, Controller } from "react-hook-form";
import ApiUserWallet from "../../../core/api/api.userWallet";
import { useLocation, useNavigate } from "react-router-dom";
import DataGridUsedPromoCodeByUser from "./DataGridUsedPromoCodeByUser";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import { TextField } from "@mui/material";
import { tools } from "../../../core/utils/tools";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";

const Index = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [checkBoxList2, setCheckBoxList2] = useState([]);
  //const [checkBoxList, setcheckBoxList] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [groupByAmuzmentService, setgroupByAmuzmentService] = useState([]);
  const [amusementServiceList, setAmusementServiceList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        const amusementserviceListFromUrl1 = searchParams.get("amusementserviceList");
        const amusementserviceListFromUrl = !_.isEmpty(amusementserviceListFromUrl1)
          ? _.toString(amusementserviceListFromUrl1)
          : 0;
        const globalSearchFromUrl = searchParams.get("globalSearch");
        const data = await ApiAgent.getAllUsedPromoCodeByUser({
          promoCode: searchParams.get("promoCode"),
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          amusmentServiceId: amusementserviceListFromUrl, // _.toString(searchParams.get('agentId')),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          globalSearch: !_.isEmpty(globalSearchFromUrl) ? globalSearchFromUrl : location?.state?.promoCodeId,
          isReturn: true,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);

        const apiData = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(apiData)) {
          setAmusementServiceList(apiData);
          // var grouped = tools.groupByListBasketItem(apiData, "amusementGroupS");
          // let objDataListGroupby = [];
          // let itemLevel = [];
          // Object.keys(grouped).map((element) => {
          //   itemLevel = [];
          //   let yy = grouped[element]?.map((item) =>
          //     itemLevel.push({
          //       value: item.id,
          //       label: item.name,
          //       //serviceId: JSON.parse(item.reserveDetails)?.Id
          //     }),
          //   );
          //   objDataListGroupby.push({ label: element, options: itemLevel });
          // });
          // setgroupByAmuzmentService(objDataListGroupby);
        } else {
          setAmusementServiceList([]);
        }
        const formInputs = [
          { name: "promoCode", type: "text" },
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          { name: "amusementserviceList", type: "multiSelect", isMulti: false, data: apiData },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, [refresh]);

  function handleChangeMulti(event) {
    setValue("amusementserviceList", event);
  }
  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  async function handleGroupEdit() {
    if (!_.isEmpty(checkBoxList2)) {
      //  location.state.set({neWPromoCategoryAgent: true,AgentId : checkBoxList2[0].id,data: checkBoxList2});
      //IncRiallBalanceForCommisonAgent
      var listId = [];
      checkBoxList2.map((item) => {
        listId.push(item.id);
      });
      var response = await ApiUserWallet.decRiallBalanceForCommisonAgent({ listBIPId: listId }).then((resp) => {
        // SwalMessage({ title:resp.message, iSsuccess: resp.data,timer:10000 });
        if (resp.data == null) {
          SwalMessage({ title: resp.message, iSsuccess: resp.data, timer: 10000 });
          return;
        }
        if (!resp.succeeded) {
          SwalMessage({
            title: resp.message,
            iSsuccess: resp.succeeded,
          });
          return;
        }
        let HtmlOutPut = resp.data.map((item) => {
          return (
            "<p class='text-md-center ml-6 ml-md-0 my-1'><span>شماره بلیط: " +
            item.data +
            " </span><span class='" +
            (item.succeeded == true ? "text-success " : "text-danger") +
            "'> تسویه : " +
            (item.succeeded == true ? "انجام شد" : "انجام نشد") +
            " </span><span> پیغام سیستم : " +
            item.message +
            "</span></p>"
          );
        });
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md mr-2 p-1 px-2 ",
            cancelButton: "btn btn-primary  btn-md ml-2 p-1 px-2 ",
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons.fire({
          html: HtmlOutPut,
          type: "success",
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: "  <small class='m-0'> بستن </small>",
        });
      });

      //setRefresh(!refresh);
      const data = await ApiAgent.getAllUsedPromoCodeByUser({
        pageSize: getValues("pageSize"),
        pageNumber: getValues("pageNumber"),
        globalSearch: location?.state?.promoCodeId,
        isReturn: true,
      });
      setListData(data);
      setValue("totalCount", data.totalCount);
    } else {
      SwalMessage({ title: "گروهی انتخاب نشده است", iSsuccess: false });
    }
  }

  const onSubmit = async (data) => {
    if (!_.isUndefined(data.promoCode) && !_.isEmpty(data.promoCode)) data.promoCode = data?.promoCode;
    if (!_.isUndefined(data.amusementserviceList) && !_.isEmpty(data.amusementserviceList))
      data.amusementserviceList = data.amusmentServiceId = data?.amusementserviceList?.value;
    if (data.fromCreatedDate && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    data.isReturn = true;
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiAgent.getAllUsedPromoCodeByUser(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount", "amusmentServiceId", "isReturn"]),
    );
    navigate(`/usedCommissionByAgentReturn?${queryString}`);
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  // const inputChangeHandlerPromoCategory = (event) => {
  //     setValue("promoCategoryId", { value: event.value, label: event.label })
  // }
  // const inputChangeHandlerAgent = (event) => {
  //     setValue("agentId", { value: event.value, label: event.label })
  // }
  // const inputChangeHandlerPromoCategoryCommision = (event) => {
  //     setValue("promoCategoryCommisionId", { value: event.value, label: event.label })
  // }
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">گزارش کمسیون های بازگشتی</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">گزارش گیری</span>
          </h3>
          <div className="card-toolbar">
            <div className="btn btn-danger mx-1">
              {" "}
              <span className="font-weight-bold font-size-sm" onClick={() => handleGroupEdit()}>
                <ArrowDownward className="mr-1" />
                برگشت از کیف پول{" "}
              </span>
            </div>
          </div>
        </div>
        {/* Start Box Header */}

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link" eventKey="0">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body className="pt-0">
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="promoCode"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="کد تخفیف"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || undefined}
                                  onInput={onChange}
                                  className="mt-5"
                                ></TextField>
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="amusementserviceList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={amusementServiceList?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  placeholder="انتخاب تفریح"
                                  className="mt-5"
                                  field={field}
                                  onChange={handleChangeMulti}
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  className="mt-5"
                                  placeholder=" از تاریخ "
                                  onChange={(date) => {
                                    var toCreatedDate = getValues("toCreatedDate");
                                    onChange(date);
                                    if (
                                      !toCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCreatedDate).getTime())
                                    ) {
                                      // Set the value of toCreatedDate to the same as toCreatedDate
                                      setValue("toCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  className="mt-5"
                                  onChange={onChange}
                                  placeholder="تا تاریخ "
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="tb-reponsive px-2 mt-2">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridUsedPromoCodeByUser
                    data={listData}
                    setCheckBoxList2={setCheckBoxList2}
                    callBack={callBackJustForRunUseEffect}
                  />
                }
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Index;
